/*
 * File: WidgetIndexPage.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 10/21/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Imports the index page for the widget.  Shows a spinner while importing.
 */

import React, { Suspense } from "react";
import UIProgress from "components/ui/UIProgress";
import PropTypes from "prop-types";

const WidgetIndexPage = ({ widget }: { widget: string }) => {
  const ClinicalComponent = React.lazy(() => import(`./${widget}/index`));

  return (
    <React.Fragment>
      <Suspense fallback={<UIProgress />}>
        <ClinicalComponent />
      </Suspense>
    </React.Fragment>
  );
};

WidgetIndexPage.propTypes = {
  widget: PropTypes.string.isRequired
};

export default WidgetIndexPage;
